import apiClient from "services/axios";

const API = {
  list: "/api/v1/channels",
  create: "/api/v1/channels",
  detail: "/api/v1/channels",
  update: "/api/v1/channels",
  delete: "/api/v1/channels",
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const create = async (body) => {
  const response = await apiClient.post(API.create, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const detail = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const update = async (id, body) => {
  const response = await apiClient.patch(`${API.update}/${id}`, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const duplicateDraft = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}/duplicate-draft`);
  if (response) {
    return response.data;
  }
  return false;
};

export const write = async (id, body) => {
  const response = await apiClient.post(`${API.detail}/${id}/write`, body, { propagateError: true });
  if (response) {
    return response.data;
  }
  return false;
};

export const writeCommandStatus = async (channelId, commandId) => {
  const response = await apiClient.get(`${API.detail}/${channelId}/write-commands/${commandId}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};
